<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Genre</h5>
            </b-col>

            <b-col align="right">
                <b-button @click="addGenre" variant="outline-secondary" size="sm" tabindex="-1">
                    <b-icon-plus></b-icon-plus>
                </b-button>
            </b-col>
        </b-row>

        <b-row v-if="!component.length">
            <b-col align="center">
                <b-list-group>
                    <b-list-group-item variant="light">
                        <small><em>No Genres</em></small>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>

        <div v-for="(genre, index) in component" v-bind:key="index">
            <b-input-group size="sm">
                <b-form-select :options="typeOptions"
                               v-model="genre.type"
                               @change="changeType(genre.type, index)" tabindex="-1">
                    <template #first>
                        <b-form-select-option :value="undefined">Genre</b-form-select-option>
                    </template>
                </b-form-select>

                <b-form-select style="width: 5rem;"
                               :ref="'genre-' + index"
                               v-if="!genre.type"
                               v-model="genre.name"
                               :state="genre.name ? null : false"
                               :options="genreList"></b-form-select>
                <b-input v-else
                         style="width: 5rem;"
                         :ref="'style-' + index"
                         :state="genre.name ? null : false"
                         v-model="genre.name"
                         :options="genreList"></b-input>

                <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="removeGenre(index)" tabindex="-1">
                        <b-icon-x></b-icon-x>
                    </b-button>
                </b-input-group-append>
            </b-input-group>
        </div>
        <!--<b-input-group size="sm" prepend="Genre">-->
            <!--<b-input :value="genre"></b-input>-->
            <!--<b-form-tags size="sm" placeholder="" disabled></b-form-tags>-->
        <!--</b-input-group>-->
    </div>
</template>

<script>
    import arrayMixin from "../../mixins/array";
    import genreList from "../../assets/genreList";

    export default {
        name: "Genre",
        props: [ 'genres' ],
        mixins: [ arrayMixin, genreList ],
        created() {
            this.clone(this.genres);
        },
        data() {
            return {
                typeOptions: [
                    { text: 'Style', value: 'style' }
                ],
            }
        },
        methods: {
            changeType(type, index) {
                if (type) {
                    this.$nextTick(() => {
                        let ref = 'style-' + index;

                        this.$refs[ref][0].$el.focus();
                    });
                } else {
                    delete this.component[index].type;
                    this.$nextTick(() => {
                        let ref = 'genre-' + index;

                        this.$refs[ref][0].$el.focus();
                    });
                }
            },
            addGenre() {
                if (this.hasGenre) {
                    this.component.push({ type: 'style', name: '' });

                    this.$nextTick(() => {
                        let index = this.component.length - 1;
                        let ref = 'style-' + index;

                        this.$refs[ref][0].$el.focus();
                    });
                } else {
                    this.component.unshift({ name: '' });
                }
            },
            removeGenre(index) {
                this.component.splice(index, 1);
            },
        },
        computed: {
            hasGenre() {
                for (let i = 0; i < this.component.length; i++) {
                    if (!this.component[i].type) {
                        return true;
                    }
                }

                return false;
            }
        }
    }
</script>

<style scoped>
</style>